// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1cgA9","question":"Question_question__1cE2m","description":"Question_description__1vmYg"};